package com.evoapps.evoshift.data.dto.system

import kotlinx.serialization.Serializable

@Serializable
data class NotificationDto(
    val id: String = "",
    val title: String = "",
    val message: String = "",
    val type: String = "",
    val createdAt: String = "",
    val isRead: Boolean = false,
    val data: Map<String, String> = emptyMap()
)
